import React,{useEffect, useState} from "react";
import "./styles.css";
import { Link } from "react-router-dom";
import classNames from "classnames";


interface Product {
  product: { name: string; img: string; price: number };
}
const Products: React.FC<any> = ({ product }) => {
  const [hover, setHover] = useState(false)

  return (
    <div onMouseOver={()=>setHover(true)} onMouseLeave={()=>setHover(false)} className="card">
      <Link to="/Detalle/1">
        <img src={product.img}></img>
        <p>{product.name}</p>
        <span>${product?.price}.00 MXN</span>
        <button className={classNames({
          hover: hover === true
        })}>Obtener</button>
      </Link>
    </div>
  );
};

export default Products;
